
import React from 'react';

function MonthFPS({ data, monthName, year }) {
  if (!data || data.length === 0) {
    return <div className="response">Details Not Found</div>;
  }
  const totalShops = data.reduce((sum, item) => sum + parseInt(item.totalShops || 0), 0);
  const onlineFps = data.reduce((sum, item) => sum + parseInt(item.onlineFps || 0), 0);
  const offlineFps = data.reduce((sum, item) => sum + parseInt(item.offlineFps || 0), 0);
  const notEnabledFps = data.reduce((sum, item) => sum + parseInt(item.notEnabledFps || 0), 0);
  const mappedFps = data.reduce((sum, item) => sum + parseInt(item.mappedFps || 0), 0);
  const notMappedFps = data.reduce((sum, item) => sum + parseInt(item.notMappedFps || 0), 0);
  return (
    <div align="center">
      <table align="center" id="Report" width="60%">
        <thead>
          <tr className="tableheader">
            <th colSpan="8">FPS Details for <font style={{ color: "orange" }}>{monthName} '{year}</font></th>
          </tr>
          <tr className="tableheader">
            <th>Sl.No</th>
            <th>District Name</th>
            <th>Total</th>
            <th>Online</th>
            <th>Offline</th>
            <th>Not Tagged</th>
            <th>Deivce<br/>Mapped</th>
            <th>Deivce Not<br/>Mapped</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{item.distName}</td>
              <td align="right">{item.totalShops}</td>
              <td align="right">{item.onlineFps}</td>
              <td align="right">{item.offlineFps}</td>
              <td align="right">{item.notEnabledFps}</td>
              <td align="right">{item.mappedFps}</td>
              <td align="right">{item.notMappedFps}</td>
            </tr>
          ))}
          <tr className="tableheader">
            <td colSpan="2">Total</td>
            <td align="right">{totalShops}</td>
            <td align="right">{onlineFps}</td>
            <td align="right">{offlineFps}</td>
            <td align="right">{notEnabledFps}</td>
            <td align="right">{mappedFps}</td>
            <td align="right">{notMappedFps}</td>
          </tr>
        </tbody>
      </table>
      <br />
    </div>
  );
}

export default MonthFPS;

